import {Injectable} from '@angular/core';
import * as Moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class DateHelperService {

  public formatDate(date: Date | string | number): string {
    const tz = Moment.tz.guess();
    return Moment.utc(date).tz(tz).format('LL');
  }

  public dateWithFormat(date: Date, format: string): string {
    if (!Moment.utc(date).isValid()) {
      return '';
    }

    const tz = Moment.tz.guess();
    return Moment.utc(date).tz(tz).format(format);
  }

  public dateWithFormatWithoutUtc(date: Date, format: string): string {
    if (!Moment(date).isValid()) {
      return '';
    }

    const tz = Moment.tz.guess();
    return Moment(date).tz(tz).format(format);
  }
}
